import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import { HttpClientbase } from './httpclientBase';
import { APPCONFIG } from '../config';
import { AppModule } from "app/app.module";
import * as moment from 'moment';
import { NotificacaoService } from './notificacao.service';
import { LoadingService } from './loading.service';

@Injectable()
export class BaseService {
    _notificacaoService: NotificacaoService;
    _router: Router;
    _http: HttpClientbase;
    _loading: LoadingService;
    _language: string = '';
    _api: string;
    constructor() {
        this._http = AppModule.injector.get(HttpClientbase);
        this._router = AppModule.injector.get(Router);
        this._notificacaoService = AppModule.injector.get(NotificacaoService);
        this._loading = AppModule.injector.get(LoadingService);
        let user = JSON.parse(localStorage.getItem('currentUserCobranca'));
        if (user && user.language)
            this._language = `/${user.language}`;
    }

    get(path: string, params: string = ''): any {
        return this._http.get(`${APPCONFIG.server}${this._language}${path}${params}`)
            .map((response: Response) => response.json())
            .catch(err => {
                return this.handleError(err);
            });
    }

    downloadFile(path: string): Observable<Blob> {
        return this._http.getFile(`${APPCONFIG.server}${this._language}${path}`)
            .map(res => res.blob())
            .catch(this.handleError)
    }

    getFiltro(path: string, model: any, pagina: number, tamanho: number): any {
        return this._http.get(`${APPCONFIG.server}${this._language}${path}?${this.modelToQueryString(model)}start=${pagina}&limit=${tamanho}`)
            .map((response: Response) => response.json())
            .catch(err => {
                return this.handleError(err);
            });
    }

    post(path: string, model: any) {
        return this._http.post(`${APPCONFIG.server}${this._language}${path}`, JSON.stringify(model))
            .map((response: Response) => response.json())
            .catch(err => {
                return this.handleError(err);
            });
    }

    put(path: string, model: any = null) {
        return this._http.put(`${APPCONFIG.server}${this._language}${path}`, JSON.stringify(model))
            .map((response: Response) => response.json())
            .catch(err => {
                return this.handleError(err);
            });
    }
    putId(path: string, id: number, model: any) {
        return this.put(path + id, model);
    }
    delete(path: string, id: number) {
        return this._http.delete(`${APPCONFIG.server}${this._language}${path}${id}`, {})
            .map((response: Response) => response.json())
            .catch(err => {
                return this.handleError(err);
            });
    }
    inativar(id) {
        return this._http.put(`${APPCONFIG.server}${this._language}${this._api}inativar/${id}`, "")
            .map((response: Response) => response)
            .catch(err => {
                return this.handleError(err);
            });
    }

    ativar(id) {
        return this._http.put(`${APPCONFIG.server}${this._language}${this._api}ativar/${id}`, "")
            .map((response: Response) => response)
            .catch(err => {
                return this.handleError(err);
            });
    }



    public handleError(error: any) {
        if (error.status == 401) {
            // this._authenticationService.token = null;
            localStorage.removeItem('currentUser');
            this._router.navigate(['/login']);
        }
        else if (error.status == 400) {
            console.log(error);
            this._notificacaoService.Erro("Ocorreu um erro", "Não foi possível executar a ação");
        }
        else if (error.status == 0) {
            this._notificacaoService.Erro("Ocorreu um erro", "Não foi possível executar a ação");
        }
        else {
            let erro = error.json();
            if (erro.hasErrors) {
                erro.errors.forEach(e => {
                    this._notificacaoService.Erro("Ocorreu um erro", e.message);
                });
            }
        }

        this._loading.fechar();

        return Observable.throw(error);
    }

    modelToQueryString(model) {
        let queryString: string = "";
        Object.keys(model).map((key) => {
            if (model[key] != undefined) {
                let prop = model[key];
                if (prop instanceof Date)
                    prop = moment(prop).format('MM/DD/YYYY')
                queryString += key + "=" + prop + "&"
            }
        });
        return queryString;
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/base.service.ts